import { TextField, Select, menuItemClasses, MenuItem } from '@mui/material';
import ModalWrapper from '../Modal/modalWrapper/basicModalWrapper';
import axios from '../../api/axiosInstance';
import { useSnackbar } from '../../utils/useSnackbar';

// Function to check if the values are changed
function areValuesChanged(data, testrundata) {
    return Object.keys(data).every(key => 
        (testrundata[key]?.trim() === data[key]?.trim())
    );
}

const EditTestRunModal = ({ isOpen, onClose, onError, onUpdate, testRunData }) => {
  const { showSnackbar } = useSnackbar();
  const handleConfirmEdit = async (data) => {
    if (areValuesChanged(data, testRunData)) {
        showSnackbar('Please change the details first!', 'error');
        return false; 
    }

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/testrun/update/${testRunData.id}`, {
        data
      });        
      onUpdate(response.data);
      onClose();
    } catch (error) {
      showSnackbar(error.response?.data?.message || 'Failed to update test run', 'error');
    }
  };

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      onClick: onClose,
    },
    {
      label: 'Update',
      variant: 'contained',
      color: 'primary',
    },
  ];

  const fields = [
    {
      Component: TextField,
      label: 'Name',
      name: 'testCycleName',
      required: true,
      autoFocus: true,
      fullWidth: true,
    },
    {
      Component: TextField,
      name: 'description',
      label: 'Description',
      multiline: true,
      rows: 3,
      autoFocus: false,
      fullWidth: true,
    },
    {
      Component: TextField,
      label: 'Start Date',
      name: 'startDate',
      required: true,
      type: 'date',
      fullWidth: true,
      InputLabelProps: { shrink: true },
    },
    {
      Component: TextField,
      label: 'End Date',
      name: 'endDate',
      required: true,
      type: 'date',
      fullWidth: true,
      InputLabelProps: { shrink: true },
    },
  ];

  return (
    <ModalWrapper
      open={isOpen}
      onClose={onClose}
      title="Edit Test Run"
      fields={fields}
      buttons={buttons}
      onSubmit={handleConfirmEdit}
      initialValues={{
        testCycleName: testRunData?.testCycleName || '',
        description: testRunData?.description || '',
        startDate: testRunData?.startDate || '',
        endDate: testRunData?.endDate || '',
      }}
    />
  );
};

export default EditTestRunModal;